// --------- 公用的 ---------
export default {
  // 表单相关
  formAbout: {
    // ----搜索相关 Start
    search: 'Search Text...',
    ordinarySearch: 'Ordinary Search',
    advancedSearch: 'Advanced Search',
    searchBtn: 'Search',
    clear: 'Clear',
    all: 'All',
    customizeFields: 'Customize the display fields',
    export: 'Export',
    rename: 'Rename',
    // ----报表相关
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    interval: 'Interval',
    auto: 'Auto',
    // ----搜索相关 End
    /* ----------------------------- */
    // ----Modal相关 Start
    ok: 'OK',
    cancel: 'Cancel',
    modal: {
      detail: 'Detail'
    },
    // ----Modal相关 End
    /* ----------------------------- */
    // 机器人与设计器 --Start
    robotName: 'RobotName',
    userStatus: 'UseStatus',
    expireDate: 'DueTime',
    createdDate: 'CreateTime',
    // 机器人与设计器 --End
    /* ----------------------------- */
    // 流程管理 --Start
    proName: 'ProcName',
    pushTime: 'PublishDate',
    desc: 'Describe',
    // 流程管理 --End
    /* ----------------------------- */
    // ----任务管理相关 Start
    robot: 'Robot',
    robotSelectTip: 'You have chosen all the robots ~',
    procName: 'ProcName',
    taskStatus: 'Status',
    taskTime: 'TaskTime',
    taskStartT: 'StartTime',
    taskEndT: 'EndTime',
    // ----任务管理相关 End
    /* ----------------------------- */
    // ----变量管理相关 Start
    variate: {
      name: 'Name',
      namePlaceH: 'Please input name',
      nameVMsg: 'The length of the variable name should be 2-64 characters, please confirm!',
      value: 'Value',
      valuePlaceH: 'Please input value',
      valueVMsg: 'The length of the variable value should be 1-128 characters, please confirm!',
      type: 'Type',
      typeV: {
        common: 'text',
        password: 'password'
      },
      description: 'Description',
      descVMsg: 'The length of the variable description should be 0-100 characters, please confirm!',
      descriptionPlaceH: 'Please input description...',
      robot: 'Robot',
      robotVMsg: 'Please select robot',
      isClientEdit: 'isClientEdit',
      isPythonExpr: 'isPythonExpr'
    },
    // ----变量管理相关 End
    /* ----------------------------- */
    // ----任务数据相关 Start
    taskData: {
      name: 'Name',
      namePlaceH: 'Please input name',
      nameVMsg: 'The space name should be 2-64 characters long, please confirm!',
      failTryTimes: 'Fail Try Times',
      failTryTimesPlaceH: 'Please input fail try times',
      failTryTimesVMsg: 'Please confirm that the maximum number of failed attempts is 99,999',
      queueMaxItems: 'Max Items',
      queueMaxItemsPlaceH: 'Please input queue max items',
      queueMaxItemsVMsg: 'The maximum number of space items is between 1 and 10000, please confirm',
      description: 'Description',
      failqueueDescVMsg: 'The description should be 0-128 characters long, please confirm!',
      descriptionPlaceH: 'Please input description...',
      robot: 'Robot',
      robotVMsg: 'Please select robot'
    }
    // ----任务数据相关 End
  },
  // 操作
  operation: {
    play: 'Play',
    deleteCurCol: 'Delete current column',
    curColTurnLeft: 'Moves to the left',
    curColTurnRight: 'Moves to the right',
    tableOperation: 'Operation',
    notAvailable: 'Not Available',
    btnAdd: 'Insert',
    btnDel: 'Delete',
    btnView: 'View',
    btnMod: 'Modify',
    save: 'Save',
    // 分页 --Start
    total: 'Total',
    items: 'items',
    totalRecords: 'A total of {total}',
    // 分页 --End
    // 机器人与设计器 --Start
    renew: 'Renew',
    expend: 'Free Extension Of 30 Days',
    monitor: 'Monitor',
    lookTask: 'View Tasks',
    tip: 'Tips',
    ok: 'Confirm',
    cancel: 'Cancel',
    downBtn: 'Download',
    // 机器人与设计器 --End
    /* ----------------------------- */
    // 流程管理/配置 --Start
    task: 'Task',
    sure: 'Preservation',
    backList: 'Return process list',
    curTask: 'Temporary tasks',
    editBtn: 'Edit',
    executeImmediately: 'Execute immediately',
    whetherExecuteImm: 'Whether the immediate execution?',
    // 流程管理/配置 --End
    /* ----------------------------- */
    // ----任务管理相关 Start
    taskLogDetail: 'Task Log Detail',
    businessLog: 'Business Log',
    taskRedo: 'Redo',
    taskRun: 'Run',
    taskStop: 'Stop',
    taskRestart: 'Restart',
    taskDel: 'Delete',
    runLogDownload: 'Run log download',
    // ----任务管理相关 End
    /* ----------------------------- */
    // ----变量管理相关 Start
    viewAccessRecord: 'View Access Record',
    variateModify: 'Modify',
    variateDel: 'Delete',
    // ----变量管理相关 End
    /* ----------------------------- */
    // ----任务数据相关 Start
    clearRecord: 'Clear Records',
    viewData: 'View Data',
    // 查看数据
    viewDetails: 'View Details',
    viewLogs: 'View Logs'
    // ----任务数据相关 End
  },
  // 提示消息
  msg: {
    canceled: 'Canceled',
    delSuceess: 'Successful deletion',
    addSuceess: 'New success',
    uploadSucess: 'Upload Success',
    proStateSucess: 'Successful process state modification',
    modifyOk: 'Modified success',
    extendOk: 'Extended success',
    clearOk: 'Clearance success',
    outErr: 'Request timeout, please try again later',
    bindOk: 'Successful unbinding',
    success: 'Successful operation',
    printMag: 'Loading, please wait...',
    payOrder: 'Creating payment order, do not operate frequently...'
  },
  notice: {
    widtdrawal: {
      title: 'Notice of Suspension',
      content: {
        0: 'Dear user:',
        1: 'We regret to inform you that we will stop supporting and serving the old version of i-Search Cloud, and officially shut down the old version platform of i-Search Cloud on December 31, 2023. ',
        2: 'We know that the old version has had an important impact on your work and business, so we have formulated an upgrade plan, which will be available to users in batches from 0:00 on July 1, 2023 to 24:00 on December 31, 2023 Start the migration service, and the migration service will end at 24:00 on January 1, 2024. At that time, the old version of i-Search Cloud platform will be officially shut down, and users will no longer be able to log in to the platform. ',
        3: 'We apologize for the inconvenience. If you have any questions about the upgrade process or need technical support, please contact our customer service team at {phone}. Our professionals will be happy to help you and make sure you go through the upgrade process smoothly. ',
        4: 'i-Search Cloud platform has been upgraded to the latest version, you can also directly visit: {link} to apply for a trial! ',
        5: 'Thank you for supporting us all the time! Looking forward to seeing you again at the new starting point. ',
        6: 'Sincerely',
        7: 'Sincerely, i-Search Team'
      },
      action: {
        ok: 'I got it'
      }
    }
  }
}
